<template>
  <div class="talent-level-container">
    <div class="list-wrap">
      <div class="tile is-parent">
        <article class="tile is-child box flex-1">
          <div class="channel-info">
            <div class="channel-info-item">
              <label class="label">频道名称</label>
              <limit-input :value.sync='name' :limit-number='5' :placeholder='"请输入频道名称"'></limit-input>
            </div>
            <div class="channel-info-item">
              <label class="label">频道简介</label>
              <input type="text" class="input" v-model="description">
            </div>
            <div class="channel-info-item">
              <label class="label">频道主编</label>
              <input type="text" class="input" v-model="editor">
            </div>
            <div class="channel-info-item">
              <label class="label">显示状态</label>
              <span class="select">
                <select v-model="status">
                  <option value="0">隐藏</option>
                  <option value="1">显示</option>
                </select>
              </span>
            </div>
          </div>
          <div class="btn-swap">
            <button class="button is-success width-1" @click="onSave">保存</button>
            <router-link style="margin-left: 20px;" :to="{ name: 'channelList'}">
              <a class="button is-info width-1">返回</a>
            </router-link>
            <button v-if="channelId" class="button is-danger width-1" @click="onDelete">删除</button>
          </div>
        </article>
        <div class="flex-space"></div>
        <article class="tile is-child box flex-3" style="max-width: 1222px;">
          <label class="label">频道关联ICON</label>
          <tag-group :source.sync="bloggerIds" label="bloggerName"></tag-group>
          <div class="icon-add" v-if="!addStatus.status">
            <span @click="onAddSingleIcon">
              <i class="fa fa-plus-circle" aria-hidden="true"></i>添加单个ICON
            </span>
            <span class="margin-left"  @click="onAddIconGroup">
              <i class="fa fa-plus-circle" aria-hidden="true"></i>添加一类ICON
            </span>
          </div>
          <div class="selected-swap" v-show="addStatus.status">
            <span v-if="addStatus.type == 0">
              <el-select v-model="selectedBlogger" filterable placeholder="请选择" class="fleft">
                <el-option
                  v-for="item in allOpts.bloggerOpts"
                  :key="item.bloggerId"
                  :label="item.name"
                  :value="item.bloggerId">
                </el-option>
              </el-select>
              <button class="button is-success" @click="confirmAddSingleIcon">确认添加</button>
              <button class="button is-danger" @click="onCancelAdd">放弃</button>
            </span>
            <span v-show="addStatus.type == 1">
              <el-select v-model="selectedIconCategoryId" filterable placeholder="请选择" class="fleft">
                <el-option
                  v-for="item in allOpts.iconCategoryOpts"
                  :key="item.categoryId"
                  :label="item.categoryName"
                  :value="item.categoryId">
                </el-option>
              </el-select>
              <button class="button is-success" @click="confirmAddIconGroup">确认添加</button>
              <button class="button is-danger" @click="onCancelAdd">放弃</button>
            </span>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
  import TagGroup from 'COMMON/TagGroup';
  import LimitInput from 'COMMON/limitInput';
  
  export default {
    components:{
      TagGroup, LimitInput
    },
    data(){
      return {
        channelId:'',
        name:'',
        description:'',
        editor:'',
        status:'1',
        bloggerIds:[],
        addStatus:{
          status:false,
          type:0 //0:添加单个ICON  1：添加一类ICON
        },
        allOpts:{
          bloggerOpts:[],
          iconCategoryOpts:[]
        },
        selectedBlogger:null,
        selectedIconCategoryId:'',
        selectedBloggerGroup:[],
        iconListPage:1,
      }
    },
    created(){
      this.init();
    },
    methods:{
      init(){
        this.channelId = this.$route.query.channelId;
        if(this.channelId){
          this.getChannel();
        }
        this.getBloggers();
        this.getIconCategoryList();
      },
      getChannel(){
        HttpRequest.get('/admin.php?method=main.getChannel',{channelId:this.channelId}).then(response => {
          response.data.bloggerIds = _.toArray(response.data.bloggerIds);
          this.channelId = response.data.channelId;
          this.name = response.data.name;
          this.description = response.data.description;
          this.editor = response.data.editor;
          this.status = response.data.status;
          this.bloggerIds = response.data.bloggerIds;
        })
      },
      getBloggers(){
        HttpRequest.get('/admin.php?method=blogger.getTopicInit').then(response => {
          this.allOpts.bloggerOpts = _.toArray(response.data.bloggers);
        })
      },
      getIconCategoryList(){
        HttpRequest.get('/admin.php?method=blogger.getIconCategoryList').then(response => {
          this.allOpts.iconCategoryOpts = _.toArray(response.data);
        })
      },
      /**
       * 添加单个ICON
       */
      onAddSingleIcon(){
        this.addStatus = {
          status : true,
          type : 0
        };
      },
      /**
       * 确认添加单个ICON
       */
      confirmAddSingleIcon(){
        if(!this.selectedBlogger){
          this.$message("请选择一个ICON!");
          return false;
        }
        let len = _.where(this.bloggerIds,{
          bloggerId:this.selectedBlogger
        }).length;
        if(!len){
          this.bloggerIds.push({
            bloggerName:this.getBloggerName(this.selectedBlogger),
            bloggerId:this.selectedBlogger
          });
        }
        this.addStatus.status = false;
      },
      /**
       * 添加一类ICON
       */
      onAddIconGroup(){
        this.addStatus = {
          status : true,
          type : 1
        };
      },
      /**
       * 放弃添加
       */
      onCancelAdd(){
        this.addStatus.status = false;
      },
      /**
       * 确认添加一类ICON
       */
      confirmAddIconGroup(){
        if(!this.selectedIconCategoryId){
          this.$message("请选择一个ICON分类！");
          return false;
        }
        this.getIconsByIconCategory();
        this.addStatus.status = false;
      },
      /**
       * 根据ICON分类获取对应的ICON
       */
      getIconsByIconCategory(){
        let params = {
          page : this.iconListPage,
          pageSize : 50,
          categoryId : this.selectedIconCategoryId
        }
        HttpRequest.get('/admin.php?method=blogger.getIconList',params).then(response => {
          _.each(response.data.list,item => {
            let len = _.where(this.bloggerIds,{
              bloggerId:item.bloggerId
            }).length;
            if(!len){
              this.bloggerIds.push({
                bloggerId:item.bloggerId,
                bloggerName:item.name
              })
            }
          })
          if(_.toArray(response.data.list).length != 0){
            this.iconListPage++;
            this.getIconsByIconCategory();
          }else{
            this.iconListPage = 1;
          }
        })
      },
      /**
       * 保存
       */
      onSave(){
        let bloggerIds = []
        _.each(this.bloggerIds,item => {
          bloggerIds.push(item.bloggerId);
        })
        let params = {
          name:this.name,
          description:this.description,
          editor:this.editor,
          status:this.status,
          bloggerIds:bloggerIds
        }
        if(this.channelId){
          params.channelId = this.channelId;
        }
        HttpRequest.post('/admin.php?method=main.doSaveChannel',params).then(response => {
          if(response.data.success){
            this.$message("保存成功！");
            this.$router.push({name:'channelList'});
          }
        })
      },
      onDelete(){
        if(!this.channelId){
          this.$message("这不是一个有效频道!");
          return false;
        }
        if(!confirm("确认删除该频道?")){
          return false;
        }
        let params = {
          type : 2,
          targetId:this.channelId
        }
        HttpRequest.post('/admin.php?method=main.deleteMainAd',params).then(response => {
          if(response.result == 0){
           this.$message("删除成功!");
           this.$router.push({name:'channelList'});
          }
        })
      },
      selectedBloggers(obj){
        if(!obj){
          this.selectedBlogger = null;
          return false;
        }
        this.selectedBlogger = obj;
      },
      selectedIconCategory(obj){
        if(!obj){
          this.selectedIconCategoryId = "";
          return false;
        }
        this.selectedIconCategoryId = obj.categoryId;
      },
      getBloggerName(id) {
        for(let item of this.allOpts.bloggerOpts) {
          if (item.bloggerId == id) {
            return item.name
          }
        }
      }
    }
  }
</script>
<style lang="less">
  .list-wrap {
    .is-parent {
      .flex-1 {
        flex-grow: 1;
      }
      .flex-3 {
        flex-grow: 3;
      }
      .flex-space {
        flex-basis: 20px;
      }
      .is-child {
        .channel-info {
          display: flex;
          flex-direction: column;
          .channel-info-item {
            height: 80px;
          }
        }
        .btn-swap {
          button {
            margin-left: 20px;
          }
        }


        .icon-add {
          font-size: 18px;
          margin-top: 10px;
          .fa {
            font-size: 26px;
          }
          span {
            cursor: pointer;
            &:hover {
              color:#1e88e5;
            }
          }
        }
        .selected-swap {
          margin-top:10px;
        }
      }
    }
  }
</style>
